<template src="./processing-fbm-shipment.pug" lang="pug"></template>

<script>
  import shipmentComponent from '@/components/fbm_shipment/shipment';
  import {
    STATUS_FAIL,
    STATUS_INIT,
    STATUS_LOADING,
    STATUS_OK,
    STATUS_PROCESSING,
    TYPE_FBM,
  } from '@/variables';
  import Pagination from '@/components/pagination/pagination';
  import DeleteModal from '@/components/modals/delete';

  export default {
    data() {
      return {
        deleteContext: null,
        status: STATUS_INIT,
        STATUS_INIT,
        STATUS_LOADING,
        STATUS_OK,
        STATUS_FAIL,
        search: '',
        shipments: null,
        page: 1,
        count: null,
        itemsPerPage: 10,
        validators: {
          tracking_code: {
            valid: null,
            regexp: /^[a-zA-Z0-9]{10,50}$/,
            validator: 'tracking_code',
          },
        },
      };
    },
    components: { shipment_component: shipmentComponent, Pagination, DeleteModal },
    created() {
      this.load();
    },
    watch: {
      page() {
        this.load();
      },
      search() {
        this.load();
      },
    },
    computed: {
      user_role() {
        return this.$store.state.users.role;
      },
    },
    methods: {
      isSubmitActive(shipment) {
        if (shipment.status === 3) return false;
        return /^[a-zA-Z0-9]{10,50}$/.test(shipment.tracking_code);
      },
      load() {
        this.status = STATUS_LOADING;

        const payload = {
          status: STATUS_PROCESSING,
          type: TYPE_FBM,
          page: this.page,
          search: this.search,
        };

        this.$store.dispatch('shipments/get_list', payload)
          .then((data) => {
            this.status = STATUS_OK;
            this.shipments = data.data;
            this.count = data.count;
          })
          .catch((err) => {
            console.log('catch', err);
            this.status = STATUS_FAIL;
          });
      },
      set_search(str) {
        this.search = str;
      },
      ship(shipment) {
        this.$store.dispatch('shipments/ship', { id: shipment.id })
          .then(() => {
            this.$set(shipment, 'status', 3);
            this.$store.dispatch('nt_set_notification',
              { type: 'inform', message: 'Shipment was shipped.' });
          })
          .catch(() => {
            this.$store.dispatch('nt_set_notification',
              { type: 'error', message: 'Shipment wasn\'t shipped. Please try again.' });
          });
      },
      addTrackingNumber(shipment) {
        this.$store.dispatch('shipments/add_tracking_code',
          { id: shipment.id, tracking_code: shipment.tracking_code })
          .then(() => {
            this.$set(shipment, 'status', 3);
            this.$store.dispatch('nt_set_notification',
              { type: 'inform', message: 'Tracking number was added.' });
          })
          .catch(() => {
            this.$store.dispatch('nt_set_notification',
              { type: 'error', message: 'Tracking number wasn\'t added. Please try again.' });
          });
      },
      validate(type, value) {
        this.validators[type].valid = this.validators[type].regexp.test(value);
      },
      isPrinted(shipment, loading) {
        loading = true;

        const data = { id: shipment.id, state: shipment.printed ? 0 : 1 };
        this.$store.dispatch('shipments/toggle_printed', data)
          .then(() => {
            loading = false;
            this.$store.dispatch('nt_set_notification',
              { type: 'inform', message: 'Printed was changed.' });
            shipment.printed = !shipment.printed;
          })
          .catch(() => {
            this.$store.dispatch('nt_set_notification',
              { type: 'error', message: 'Printed wasn\'t changed. Please try again.' });
          });
      },
      deleteShipment() {
        if (!this.deleteContext) return;
        this.$store.dispatch('shipments/delete', { id: this.deleteContext })
          .then(() => {
            this.deleteContext = null;
            this.load();
            this.$store.dispatch('nt_set_notification',
              { type: 'inform', message: 'Shipment was deleted.' });
          })
          .catch(() => {
            this.$store.dispatch('nt_set_notification',
              { type: 'error', message: 'Shipment wasn\'t created. Please try again.' });
          });
      },
      showDeleteModal(id) {
        this.deleteContext = id;
      },
    },
  };
</script>
